import { ComponentSingleStyleConfig } from "@chakra-ui/react";

const Spinner: ComponentSingleStyleConfig = {
  baseStyle: {
    color: "red.lead",
  },
};

export default Spinner;
